<template>
  <!-- While its data loads, the Flexigo loader stands in for the tile, at the tile's usual height. -->
  <div v-if="loading" class="loadingApp position-relative" :style="{ minHeight: loaderHeight }">
    <div class="imgContainer">
      <img :src="loaderSrc" alt="" />
    </div>
  </div>
  <div v-else class="dashboard-tile">
    <slot />
  </div>
</template>

<script>
/**
 * The frame of a flexiShuttle dashboard tile (Ride Requests, Number of Riders, Occupancy Ratios, Devices and
 * Actions): a white bordered box, or the Flexigo loader while the tile's data loads. Spacing and height classes
 * set on the tile apply in both states.
 */
export default {
  name: 'DashboardTile',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    // The loader's height, so the page doesn't jump when the tile replaces it, e.g. '491px'.
    loaderHeight: {
      type: String,
      default: undefined,
    },
  },
  setup() {
    return { loaderSrc: `${process.env.BASE_URL}flexigo-loader.gif` };
  },
};
</script>

<style lang="scss" scoped>
.dashboard-tile {
  background-color: var(--color-surface-raised);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm);
}
</style>
